import { createFileRoute } from '@tanstack/react-router';

import { GroundTruthEditorShell } from '@/features/GroundTruthHub/GroundTruthEditorShell';
import { GroundTruthPreview } from '@/features/GroundTruthHub/GroundTruthPreview';
import { PageSplitEditor } from '@/features/GroundTruthHub/PageSplitEditor';
import { isNotFoundError, useGtFileDocs } from '@/features/GroundTruthHub/api';
import { ingestedFileIdParams } from '@/features/GroundTruthHub/routeParams';
import {
    GroundTruthNotFound,
    groundTruthRouteBoundaries,
} from '@/features/GroundTruthHub/GroundTruthNotFound';

/** Exported so it can be unit-tested with plain props; see `sheets.test.tsx`. */
export function PageSplitRoute({ ingestedFileId }: { ingestedFileId: number }) {
    const { data: docs, error } = useGtFileDocs(ingestedFileId);

    if (isNotFoundError(error)) {
        return <GroundTruthNotFound what={`File #${ingestedFileId}`} />;
    }

    return (
        <GroundTruthEditorShell title={`Page splits — file #${ingestedFileId}`}>
            <GroundTruthPreview docId={docs?.[0]?.id ?? null}>
                <PageSplitEditor ingestedFileId={ingestedFileId} />
            </GroundTruthPreview>
        </GroundTruthEditorShell>
    );
}

function PageSplitRouteComponent() {
    const { ingestedFileId } = Route.useParams();
    return <PageSplitRoute ingestedFileId={ingestedFileId} />;
}

export const Route = createFileRoute('/ground-truth/$ingestedFileId/pages')({
    ...groundTruthRouteBoundaries,
    component: PageSplitRouteComponent,
    params: ingestedFileIdParams,
});
